import React, { Component } from 'react'
import { Container, Row, Col } from '../../../../../v2SPRINTA/atoms/Grid'
import Display from '../../../../../v2SPRINTA/atoms/Display'
import ProgressBar from '../../../../../SPRINTA/atoms/ProgressBar'

class ContentInfo extends Component {

    render() {
        return (
            <Container>
                <Row style={{ paddingTop: '60px', paddingBottom: '45px' }}>
                    <Col size='12 12 4' text='left left right' style={{ paddingBottom: '30px' }}>
                        <Display size={2}>
                            {this.props.title}
                        </Display>
                        <br />
                        <span dangerouslySetInnerHTML={{ __html: this.props.description}} />

                        {this.props.steps && this.props.steps.self === this.props.steps.current && (
                            <Row justifyContent='center center end' style={{ marginTop: '30px' }}>
                                <Col size='12 12 8'>
                                    <ProgressBar theme='orange' progress={this.props.steps.current * 100 / this.props.steps.size} />
                                    <span>
                                        Passo {this.props.steps.current} de {this.props.steps.size}
                                    </span>
                                </Col>
                            </Row>
                        )}
                        
                    </Col>
                    <Col size='12 12 8' style={{ paddingTop: '10px' }}>
                        {this.props.children}
                    </Col>
                </Row>
            </Container>
        )
    }

}

export default ContentInfo


// WEBPACK FOOTER //
// ./src/App/pages/CreateExperience/Steps/_ContentInfo/index.js